
import { RdExpenditureYear } from './rd-expenditure-year.model';

export class LqreCalculation {
  year: RdExpenditureYear;

  constructor(taxCreditCalculation?: any) {
    if (taxCreditCalculation) {
      Object.assign(this, taxCreditCalculation);
    }
  }
}
